var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "uom-mask" }, [
        _c("div", { staticClass: "uom-modal" }, [
          _c(
            "div",
            { staticClass: "uom-header" },
            [
              _c("svg-icon", {
                attrs: { "icon-class": "icon_zhuyi", "class-name": "c-F53F3F" },
              }),
              _c("span", { staticClass: "uom-title" }, [
                _vm._v("无法禁用该员工"),
              ]),
              _c("i", {
                staticClass: "el-icon-close uom-close",
                on: { click: _vm.close },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "uom-subtitle" }, [
            _vm._v(" 员工「" + _vm._s(_vm.userName) + "」存在 "),
            _c("em", { staticClass: "uom-count" }, [
              _vm._v(_vm._s(_vm.displayItems.length)),
            ]),
            _vm._v(" 项未解除的业务占用，禁用前需先处理以下事项： "),
          ]),
          _c("div", { staticClass: "uom-list-header" }, [
            _c("span", [
              _vm._v("占用明细（" + _vm._s(_vm.displayItems.length) + " 条）"),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "uom-list" },
            _vm._l(_vm.displayItems, function (item, idx) {
              return _c(
                "div",
                { key: idx, staticClass: "uom-item" },
                [
                  _c("div", { staticClass: "uom-item-main" }, [
                    _c("div", { staticClass: "uom-item-num" }, [
                      _vm._v(_vm._s(idx + 1)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "uom-item-body" },
                      [
                        _c("div", { staticClass: "uom-item-title" }, [
                          _c("span", { staticClass: "uom-type-label" }, [
                            _vm._v(_vm._s(item.typeLabel || "业务占用")),
                          ]),
                          item.manageName
                            ? _c(
                                "span",
                                {
                                  staticClass: "uom-manage-link",
                                  on: {
                                    click: function ($event) {
                                      return _vm.goManage(item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.manageName))]
                              )
                            : _vm._e(),
                        ]),
                        _vm.isAggregateItem(item)
                          ? [
                              item.type !== "DELIVERY_ASSISTANT"
                                ? _c("div", { staticClass: "uom-item-row" }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "uom-row-value uom-aggregate-title",
                                      },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "uom-item-row uom-handle-method",
                                },
                                [
                                  _c("span", { staticClass: "uom-row-label" }, [
                                    _vm._v("处理方式："),
                                  ]),
                                  _c("span", { staticClass: "uom-row-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        item.handleMethod ||
                                          "TODO: 暂未提供处理方式"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          : [
                              item.type === "TEACHING_ASSISTANT_ONLY"
                                ? _c("div", { staticClass: "uom-item-row" }, [
                                    _c(
                                      "span",
                                      { staticClass: "uom-row-value" },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                  ])
                                : item.type !== "SALE_USER_OCCUPANCY" &&
                                  item.type !== "DELIVERY_HEADTEACHER" &&
                                  item.type !== "DELIVERY_ASSISTANT"
                                ? _c(
                                    "div",
                                    { staticClass: "uom-item-row" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "uom-row-label" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.rowTitleLabel(item)) +
                                              "："
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "uom-row-value" },
                                        [_vm._v(_vm._s(item.title || "—"))]
                                      ),
                                      item.itemId &&
                                      item.type !== "DELIVERY_HEADTEACHER" &&
                                      item.type !== "FEISHU_REMINDER"
                                        ? [
                                            _c("span", {
                                              staticClass: "uom-row-divider",
                                            }),
                                            _c(
                                              "span",
                                              { staticClass: "uom-row-label" },
                                              [_vm._v("任务ID：")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "uom-row-value" },
                                              [_vm._v(_vm._s(item.itemId))]
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              item.extraList && item.extraList.length
                                ? _c(
                                    "div",
                                    { staticClass: "uom-extra-list" },
                                    _vm._l(item.extraList, function (line, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: i,
                                          staticClass: "uom-extra-row",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "uom-row-value" },
                                            [_vm._v(_vm._s(line))]
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm.shouldShowRelatedUser(item)
                                ? _c("div", { staticClass: "uom-item-row" }, [
                                    _c(
                                      "span",
                                      { staticClass: "uom-row-label" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.relatedUserLabel(item)) +
                                            "："
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "uom-row-value" },
                                      [_vm._v(_vm._s(item.relatedUserName))]
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "uom-item-row uom-handle-method",
                                },
                                [
                                  _c("span", { staticClass: "uom-row-label" }, [
                                    _vm._v("处理方式："),
                                  ]),
                                  _c("span", { staticClass: "uom-row-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        item.handleMethod ||
                                          "TODO: 暂未提供处理方式"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                      ],
                      2
                    ),
                  ]),
                  _vm.isAggregateItem(item)
                    ? _c(
                        "el-button",
                        {
                          staticClass: "uom-go-btn",
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleGo(item)
                            },
                          },
                        },
                        [_vm._v("批量更换助教")]
                      )
                    : _c(
                        "el-button",
                        {
                          staticClass: "uom-go-btn",
                          attrs: { type: "primary", size: "small" },
                          on: {
                            click: function ($event) {
                              return _vm.handleGo(item)
                            },
                          },
                        },
                        [_vm._v("去处理")]
                      ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "uom-footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.close } },
                [_vm._v("我知道了")]
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }